import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { useEffect } from 'react';
import { useState } from 'react';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

export const ThankYouPoletniNakupi2025 = ({hibisId, scAnswer}) => {

  const [hero, setHero] = useState({});
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [button, setButton] = useState('');
  const [cta, setCta] = useState('');
  const [loanValue, setLoanValue] = useState(1000);
  const [loanChanged, setLoanChanged] = useState(false);
  const [ctaWarning, setCtaWarning] = useState(false);
  const [formShown, setFormShown] = useState(false);

  useEffect(() => {
    const contentMap = {
      "travel": {
        "hero": {
          "image": "oskar-tulipani.jpg",
          "xPos": "22%",
          "yPos": "32%"
        },
        "subject": "Kam bi odpotovali letošnjo jesen?",
        "content": "Si predstavljate, da bi si letošnjo jesen privoščili nekaj drugačnega? Znesek do 15.000 € vam lahko omogoči izkušnjo, ki jo boste pomnili še dolga leta.",
        "button": "ZANIMA ME FINANCIRANJE SANJSKEGA POTOVANJA",
        "cta": "👉 Preverite, kako si lahko hitro zagotovite svojo naslednjo izkušnjo."
      },
      "credit": {
        "hero": {
          "image": "oskar-finance.jpg",
          "xPos": "49%",
          "yPos": "22%"
        },
        "subject": "Je čas, da poenostavite svoje finančne obveznosti?",
        "content": "Vam stari dolgovi obremenjujejo vsakdan? Poenostavite svoje finance in lažje zadihajte z ugodnim gotovinskim kreditom.",
        "button": "ZANIMA ME UGODNEJŠE FINANCIRANJE",
        "cta": "👉 Preverite možnosti, kako lahko poenostavite svoje finance."
      },
      "home": {
        "hero": {
          "image": "oskar-dom.jpg",
          "xPos": "28%",
          "yPos": "21%"
        },
        "subject": "Kaj bi najprej prenovili v vašem domu?",
        "content": "Morda je zdaj pravi trenutek za osvežitev doma. Z ustreznim financiranjem lahko uresničite tisto, kar že (pre)dolgo načrtujete.",
        "button": "ZANIMA ME FINANCIRANJE PRENOVE DOMA",
        "cta": "👉 Preverite, kako obsežno prenovo doma si lahko privoščite."
      },
      "car": {
        "hero": {
          "image": "oskar-avto.jpg",
          "xPos": "52%",
          "yPos": "37%"
        },
        "subject": "Razmišljate o menjavi avtomobila?",
        "content": "Se sprašujete, ali je zdaj pravi čas za zamenjavo avtomobila? Morda je ravno sedaj pravi trenutek, da si privoščite vozilo, ki vam kar najbolj ustreza.",
        "button": "ZANIMA ME FINANCIRANJE AVTOMOBILA S KREDITOM",
        "cta": "👉 Preverite, kakšen avtomobil si lahko privoščite."
      },
      "lifestyle": {
        "hero": {
          "image": "oskar-interesi.jpg",
          "xPos": "28%",
          "yPos": "44%"
        },
        "subject": "Kaj bi izbrali: ogromen TV, e-kolo ali ameriški hladilnik?",
        "content": "Zakaj bi odlašali z opremo, ki izboljša vaš vsakdan? Investicija v udobje ali funkcionalnost doma je danes bolj dosegljiva kot kadarkoli.",
        "button": "ZANIMA ME FINANCIRANJE OPREME ZA DOM ALI PROSTI ČAS",
        "cta": "👉 Preverite višino zneska, s katerim lahko vaš dom ali preživljanje prostega časa nadgradite brez velikih začetnih vložkov."
      },
      "health": {
        "hero": {
          "image": "oskar-brezrokavnik.jpg",
          "xPos": "76%",
          "yPos": "34%"
        },
        "subject": "Kaj bi naredili za boljše počutje?",
        "content": "Nasmeh, gibljivost, videz – stvari, ki pomembno vplivajo na vsakdan. Če vas katero od teh področij bremeni, obstaja pot do izboljšanja.",
        "button": "ZANIMA ME FINANCIRANJE SAMOPLAČNIŠKE ZDRAVSTVENE STORITVE",
        "cta": "👉 Preverite, koliko obsežne zdravstvene storitve lahko financirate s pomočjo gotovinskega kredita."
      }
    };

    const normalized = scAnswer?.toLowerCase();
    const fallback = 'credit';
    if (!normalized || !contentMap[normalized]) {
      console.log('Falling back to Home category.')
    }

    setSubject(contentMap[normalized ?? fallback].subject);
    setHero(contentMap[normalized ?? fallback].hero);
    setContent(contentMap[normalized ?? fallback].content.replace(/\n/g, '<br />'));
    setButton(contentMap[normalized ?? fallback].button);
    setCta(contentMap[normalized ?? fallback].cta);

  }, [scAnswer]);

  const handleSliderChange = (newValue) => {
    setLoanChanged(true);
    setLoanValue(newValue);
    setCtaWarning(false);
  };

  const handleCtaClick = () => {
    if (!loanChanged) {
      // prevent CTA click due to loan value not being selected first
      setCtaWarning(true);
    } else {
      // loan value has been selected, so CTA click is valid
      setCtaWarning(false);
      setFormShown(true);
    }
  };

  return (
    <>
      <Header />
      <Hero image={hero.image} xPos={hero.xPos} yPos={hero.yPos} />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>{subject}</h1>
                    <p className="text-left" dangerouslySetInnerHTML={{ __html: content }}>
                    </p>
                    <p className="text-left">
                      <b>{cta}</b>
                    </p>
                    <p className="text-left text-small">
                        <br />
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                { !formShown && (
                  <Col md={5} className="p-3">                  
                    <p style={{color: "#FD5669"}}>
                      <b>
                        <br />Izberite znesek, ki vam ustreza:
                      </b>
                    </p>
                    <Slider 
                      max={15000} 
                      min={1000}
                      onChange={handleSliderChange}
                      step={100}
                      styles={{
                          track: { backgroundColor: "#FD5669", height: "6px" },
                          rail: { backgroundColor: "#ffb8c0", height: "6px" },
                      }}
                    />
                    {loanValue.toLocaleString('de-DE')} EUR
                    <p>
                      <br />
                      <div 
                          className={'addiko-btn'} 
                          onClick={handleCtaClick}
                          role='button'
                          tabIndex={0}
                          style={{
                            cursor: 'pointer',
                            opacity: loanChanged ? 1.0 : 0.5 
                          }}
                      >
                          {button}
                      </div>                                            
                    </p>
                    {ctaWarning && (
                      <p className="text-left text-small" style={{color: '#ee5a66'}}>
                        Prosimo, da najprej izberete želeni znesek.
                      </p>
                    )}
                  </Col>
                )}
                { formShown && (                  
                  <Col md={5} className="p-3">  
                    <p className="text-left text-small-desktop">
                      Če potrebujete financiranje v znesku <span style={{whiteSpace: 'nowrap'}}><b>{loanValue.toLocaleString('de-DE')} EUR</b>,</span> vnesite svoje kontaktne podatke in poklicali vas bomo v kratkem!
                    </p>
                    <div>
                      <Form guid="03930c38-5857-482c-924f-1c4dca611318" hibisId={hibisId} />
                    </div>
                    <p className="divider">
                      <span>ALI</span>
                    </p>
                    <p>
                      <a 
                          className={'addiko-btn addiko-btn-outlined'} 
                          href="https://hipkredit.addiko.si/kreditnaspletu/sl/izracun"
                          rel="noopener noreferrer"
                          target="_blank"
                      >
                          OBIŠČITE SPLETNI KALKULATOR
                      </a>       
                    </p>
                  </Col>
                )}
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}